var aula = { 
	rateList : function(publicationId, page){
        $('#idDivRate').find(".more-answer").find("a").append("<i class='ico-loading'></i>");
        $.ajax({
            url : '/es/course/rate', 
            type : 'POST',
            dataType : 'json',
            data : {publicationId: publicationId, page: page, limit:4, 'type': 'single'},
            success : function(data) {
                if(data.success) {
                    if(data.partnerId == 1) {
                        $('#idDivRate').find(".more-answer").remove();
                        $('#idDivRate').append(data.html);
                    } else {
                        $('#idDivRate').find(".more-answer").remove();
                        $('#idDivRate').append(data.html);
                    }
                } else {
                    $(elem).removeClass("btn-disable");
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                    });
                }
            }  
        });
    }, 
	timeToDescription : function(time) 
	{
		if (time instanceof Date === false) {
			time = new Date(Date.parse(time)); 
		}
		var desc = "...";
		var now = new Date();
		var howLongAgo = (now - time);
		var seconds = Math.round(howLongAgo / 1000);
		var minutes = Math.round(seconds / 60);
		var hours = Math.round(minutes / 60);
		if (seconds === 0) {  
			desc = "ahora";
		} else if (minutes < 1) {
			desc = seconds + " segundo" + (seconds !== 1 ? "s" : "") + " ";
		} else if (minutes < 60) {
			desc = "hace " + minutes + " minuto" + (minutes !== 1 ? "s" : "")
					+ " ";
		} else if (hours < 24) {
			desc = "hace " + hours + " hora" + (hours !== 1 ? "s" : "") + " ";
		} else {
			desc = time.getDate()
					+ " "
					+ [ "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Aug",
							"Sept", "Oct", "Nov", "Dic" ][time.getMonth()]
		}
		return '<span>'+desc+'</span>';
	},
	loadValorationIndicator : function()
	{
		$.ajax({
			url : '/es/class-room/valoration-indicator', 
			type : 'POST',
			dataType : 'json',
			data : {publicationId:og.params.productoId},
			success : function(data) {
				var html = '';
				if(data.success) {
					$.each(data.data, function( index, value ) {
						html += '<div class="col-md-6">'+
							'<div class="clear-fix list-question">'+
								'<p>'+value.name+'</p>'+
								'<span>Malo</span>'+
								'<div class="star-list" data-calif="true">'+
									'<i class="far fa-star" data-id="'+value.id+'" data-point="5"></i>'+
									'<i class="far fa-star" data-id="'+value.id+'" data-point="4"></i>'+
									'<i class="far fa-star" data-id="'+value.id+'" data-point="3"></i>'+
									'<i class="far fa-star" data-id="'+value.id+'" data-point="2"></i>'+
									'<i class="far fa-star" data-id="'+value.id+'" data-point="1"></i>'+
								'</div>'+
								'<span>Excelente</span>'+
							'</div>'+
						'</div>';
					});
					$('#idDivIndicator').html(html);
					main.startCal();
				}
			}  
		})
	},
	sendCommentCalificate : function()
	{
		$("#idFormCalification").validate({ 
			rules: {
				comentCalification: {   
					required: true 
				}
			}, 
			messages: {
				comentCalification: {
					required: "Por favor ingrese su comentario"
				}
			},
			errorPlacement: function(error, element) {
				error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
			 },
			submitHandler: function(form) {
				var params = og.params; 
				params.qestiontext = $('#comentCalification').val();
				params.channel = aulaComment.configs.channelName;
				$("#idButtonComentCalification").addClass('btn-disable');
				$.ajax({
					url : '/es/class-room/save-comment', 
					type : 'POST',
					dataType : 'json',
					data : params,
					success : function(data) {
						if(data.success) {
							$('#calificacionModal').modal('hide');
						}
					}  
				})
			}
		});
	},
	roomLivePlay: function(url) {
        $.ajax({
            url: "/es/class-room-live-stream/" + id + '/' + quotesId,
            //data: {'slug': slug},
            type: 'GET',
            dataType: "json",
            beforeSend: function() {
                // --
             },
            success: function (data) {
                if(data.liveStream) {
                    var player = jwplayer("idMedia").setup({
                        file: data.liveStream,
                        autostart: "true",
                        mute:"false"
                    })
                    
                    player.on('error', function(event){
                        this.stop();
                    });
                }
            }
        });
    },
    roomLiveStream: function (id) {
    	if(id) {
    		var offset = new Date().getTimezoneOffset();
			console.log(offset);
    		$.ajax({
	            url: "/es/class-room/show-session-live?id=" + id ,
	            data: {'timezone': moment.tz.guess()},
	            type: 'GET',
	            dataType: "json",
	            beforeSend: function() {
	                console.log('Loading...');
	             },
	            success: function (data) {
	                if(data.html) {
	                    $("#media-live-stream").html(data.html);
	                    setTimeout(function(){
	                        custom.countDown();
	                        //examen.validateFormIE();
	                        if(data.urlStream) {
		                    	var player = jwplayer("idMedia").setup({
			                        file: data.urlStream,
			                        autostart: "true",
                        			mute:"false"
			                    })
			                    
			                    player.on('error', function(event){
			                        this.stop();
			                    });
		                    }
	                    }, 300);               
	                }
	            }
	        });
    	}
    	return false;
	        
    },
    getPusherLive: function() {
        console.log('pusher');
        pusher = new Pusher(og.params.key)
        var channel = pusher.subscribe(og.params.channelNameLive);
        channel.bind(event.configs.eventName, function(data) {
            console.log('pusher renderStream');
            aula.roomLiveStream(data.id);
        });

    }
}  

